<template>
      <div class="ft-modal-container">
        <b-modal id="ft-demand-details-modal" hide-footer hide-header @hidden="resetForm" class="ft-demand-details" title="select-vehicle-types">
            <template v-slot:modal-header>
                <h5>Demand Details</h5>
            </template>
            <b-container style="padding: 0">
                <div class="demand-details" style="margin-top: 0px;">
                    <b-container>
                    <div>
                        <div v-if="showNotification" class="ft-notification">
                            <status-banner :data="item"/>
                        </div>
                        <div class="demand-details-content">
                        <b-row>
                            <b-col cols="12" class="ft-route-details">
                            <h4 class="ft-route">
                                {{ item.origin }} - {{ item.destination }}
                            </h4>
                            <!-- <p class="ft-route-time small-text">Reporting {{reportingTime}}</p> -->
                            </b-col>
                        </b-row>

                <b-row class="vehicle-material-details">
                  <b-col cols="7">
                    <h6 class="ft-vehicle">
                      <icon-base name="truck" icon-name="truck" width="18" height="16">
                        <icon-truck/>
                      </icon-base>
                      <span>{{ vehicleDetail }}</span>
                    </h6>
                    <span class="small-text grey-text-1 pdl-38">{{ item.truck_size }}</span>
                  </b-col>
                  <b-col cols="5" v-if="item.material">
                    <h6 class="ft-material">
                      <icon-base name="material" icon-name="material" width="15" height="20">
                        <icon-material/>
                      </icon-base>
                      <span>{{ item.material }}</span>
                    </h6>
                  </b-col>
                </b-row>

                <b-row class="demand-controls">
                  <b-col cols="5" style="padding-right: 1px">
                    <b-form-group v-if="item.trucks_required > 1">
                      <label for="vehicle-qty" class="d-block">{{ $t('message.biddingFor') }}</label>
                      <b-form-spinbutton id="vehicle-qty" v-model="vehicle_qty" min="1" :max="item.trucks_required"
                                         class="mb-2 btn-spinner"></b-form-spinbutton>
                    </b-form-group>
                    <b-form-group v-if="item.trucks_required == 1">
                      <label for="vehicle-qty" class="d-block">{{ $t('message.biddingFor') }}</label>
                      <div @click="onClickInputQty">
                        <b-form-input class="vehicle-qty-readonly" id="vehicle-qty" v-model="vehicle_qty"
                                    :value="vehicle_qty" disabled style="text-align: center"></b-form-input>
                      </div>
                      
                    </b-form-group>
                  </b-col>
                  <b-col cols="2" style="text-align: center;margin-top: 35px;">
                                <span class="">
                                    <icon-base icon-name="close" width="20" height="14"><icon-close/></icon-base>
                                </span>
                  </b-col>
                  <b-col cols="5" style="padding-left: 1px">
                    <b-form-group
                        class="mb-0">
                      <label for="vehicle-rate" class="d-block">{{ $t('message.vehicleRateLabel') }}</label>
                      <b-form-input id="vehicle-rate" v-model="biddingprice" @blur="isInputActive = false"
                                    @focus="isInputActive = true"
                                    @input="$v.rate_received.$touch()"
                                    :state="$v.rate_received.$dirty ? !$v.rate_received.$error : null"
                                    :disabled="editMode"
                                    placeholder=""></b-form-input>

                    </b-form-group>
                  </b-col>
                  <b-col v-if="$v.rate_received.$error" class="feedback-text error-text" cols="12">
                    <span>{{ $t('message.invalidBidAmount') }}</span>
                  </b-col>
                  <b-col v-if="rate_received >= '1000'" class="feedback-text valid-text" cols="12">
                    <span>{{ $t('message.validAmountText') }}</span>
                  </b-col>

                  <b-col cols="12" v-if="editMode">
                    <b-alert show style="padding: 0.5rem; background-color: rgba(230,242,255,255);">
                      <b-row>
                        <b-col cols="5"><p class="vertical-center">Edit Truck Rate:</p></b-col>
                        <b-col cols="7">
                          <b-button-group>
                            <b-button class="btn ft-btn" variant="light"
                                      :disabled="rate_received <= 0 || (rate_received - stepperValue) < 1000"
                                      @click="handleChangePrice('decrement')">- 500
                            </b-button>
                            <b-button class="btn ft-btn" variant="light"
                                      :disabled="rate_received + stepperValue > item.demand_status_details.rate"
                                      @click="handleChangePrice('increment')">+ 500
                            </b-button>
                          </b-button-group>
                        </b-col>
                      </b-row>
                    </b-alert>
                  </b-col>

                  <b-col cols="4">
                    <b-button class="ft-btn text-black" variant="outline-dark" @click="closeModal">
                      {{ $t('message.modalCancelBtnText') }}
                    </b-button>
                  </b-col>
                  <b-col cols="8" style="padding-left: 0">

                    <div class="place-bid-btn">
                      <b-button class="ft-btn"
                                :disabled="(showPlaceBidLoader || $v.$invalid) || (editMode && rate_received >= item.demand_status_details.rate)"
                                block variant="primary" @click="submitBid">
                        <b-spinner v-if="showPlaceBidLoader" small label="Small Spinner"></b-spinner>
                        {{ rate_received > 0 ? totalPrice + ' &bull; ' : '' }}
                        {{ !editMode ? $t('message.placeBidBtnText') : $t('message.editBid') }}
                      </b-button>
                    </div>
                  </b-col>
                  <b-col v-if="editMode && rate_received >= item.demand_status_details.rate"
                         class="feedback-text error-text" cols="12" style="margin-top: 0.5rem">
                    <span>{{ $t('message.editBidErrorText') }}</span>
                  </b-col>
                </b-row>

              </div>

            </div>

          </b-container>
        </div>
      </b-container>

      <!-- <template v-slot:modal-footer>
          <div>
              <div class="ft-modal-form-control">
                  <b-button class="mr-2" variant="secondary">{{$t('message.modalCancelBtnText')}}</b-button>
                  <b-button variant="primary">Bid Now</b-button>
              </div>
          </div>
      </template> -->
    </b-modal>
  </div>
</template>

<script>
import IconBase from '../IconBase.vue'
import IconTruck from '../icons/IconTruck.vue'
import IconMaterial from '../icons/IconMaterial.vue'
import IconClose from '../icons/IconClose.vue'
import moment from 'moment'
import StatusBanner from '../StatusBanner.vue'
import axios from 'axios'

import {required} from 'vuelidate/lib/validators'

import {MX_TRACK} from '../../utils/Mixpanel.js'
import config from '../../config/config.js'

const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL

const rateGreaterThanZero = (value) => {
  return (parseInt(value) >= 1000)
}

export default {
  name: 'DemandDetailsModal',
  props: {
    item: Object
  },
  components: {
    IconBase,
    IconTruck,
    IconMaterial,
    IconClose,
    StatusBanner
  },
  data() {
    return {
      isInputActive: false,
      vehicle_qty: 0,
      rate_received: 0,
      bidPlaced: false,
      showPageLoader: true,
      showPlaceBidLoader: false,
      editMode: false,
      stepperValue: 500,
      stepperCount: {
        up: 0,
        down: 0
      }
    }
  },
  validations: {
    rate_received: {
      required,
      rateGreaterThanZero
    }
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler: function () {
        this.editMode = this.item.demand_status_details?.is_edit_allowed
        if (this.item.demand_status_details?.is_edit_allowed) {
          this.rate_received = this.item.demand_status_details?.lowest_bid.rate - this.stepperValue || 0
        } else {
          this.rate_received = this.item.demand_status_details?.rate || 0
        }
        this.vehicle_qty = this.item.trucks_required || 0

        this.trackMixpanelEvent('SET_TRUCK_QUANTITY', {'QTY': this.item.trucks_required})
      }
    }
  },
  mounted() {
    // const _this = this;
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      console.log(modalId, bvEvent)
      // if (modalId == 'ft-demand-details-modal') {
      //     _this.editMode = _this.item.demand_status_details?.is_edit_allowed
      //     _this.rate_received = _this.item.demand_status_details?.rate || 0
      //     _this.vehicle_qty = _this.item?.trucks_required || 0
      // }

    })
  },
  computed: {
    showNotification: function(){
      return this.$route.params.id !== undefined
    },
    bidPlacedAt: function () {
      return moment(this.item.bid_placed_at || new Date()).fromNow()
    },
    vehicleDetail: function () {
      return this.item.trucks_required + ' x ' + this.item.truck_type
    },
    biddingprice: {
      get: function () {
        if (this.isInputActive) {
          return this.rate_received.toString()
        } else {
          return this.formatPrice(this.rate_received)
        }
      },
      set: function (modifiedValue) {
        let newValue = parseFloat(modifiedValue);
        if (isNaN(newValue)) {
          newValue = 0
        }
        this.rate_received = newValue
      }
    },
    totalPrice() {
      const totalPrice = this.rate_received * this.vehicle_qty
      return this.formatPrice(totalPrice)
    },
    reportingTime() {
      return this.item.expected_reporting_date
    }
  },
    methods: {
        formatPrice(price) {
            if (price !== '')
                return "₹ " + price.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
            else
                return '₹ '
        },
        async submitBid() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.showPlaceBidLoader = true
                const reqData = {
                    "rate_received": this.rate_received,
                    "vehicle_qty": this.vehicle_qty
                }
                if(this.showNotification){
                    try {

                    // console.log(reqData)
                    // const data = {"success":true,"value":{"status":"OPEN","rate":1234.0,"trucks_supplied":1,"winning_bid":null}}
                    // if (data.success) {
                    // this.toast('success', 'b-toaster-bottom-center', `${this.item.origin} - ${this.item.destination} ${this.$t('message.placeBidSuccessMsgText', [this.rate_received])}`, true)
                    // this.$emit('update-demand-list', this.item.unique_id, data)
                    // }
                    const reqUrl = this.editMode ?
                        `${API_BASE_URL}/bid/edit/${this.item.unique_id}` :
                        `${API_BASE_URL}/bid/place/${this.item.unique_id}`;
                    const {data} = await axios.post(reqUrl, reqData)
                    if (data.success) {
                        // this.getDemadDetails()
                        this.bidPlaced = true
                        this.toast('success', 'b-toaster-bottom-center', `${this.item.origin} - ${this.item.destination} ${this.$t('message.placeBidSuccessMsgText', [this.rate_received])}`, true)
                        this.closeModal()
                        this.$emit('update-demand-list', this.item.unique_id, data)
                        // this.$emit('update-demand-list', data)
                        //
                        let eventName = ""
                        let mx_prop = {}
                        if (this.editMode) {
                        eventName = config.MIXPANEL_EVENTS.EDIT_BID_ON_SUBMIT_UPDATE_RATE
                        mx_prop = {
                            original_bid: this.item.demand_status_details.rate,
                            previous_bid: this.item.demand_status_details.rate,
                            lowest_bid: this.item.demand_status_details.lowest_bid.rate,
                            new_bid: this.rate_received,
                            bid_value_difference: this.rate_received - this.item.demand_status_details.rate
                        }
                        } else {
                        eventName = config.MIXPANEL_EVENTS.SUBMIT_RATE
                        const {supplier_id, demand_id} = this.item
                        mx_prop = {
                            freight_value: data.value.rate_received,
                            vehicle_count: data.value.trucks_supplied,
                            time: new Date().getTime(),
                            user_id: supplier_id,
                            page_src: this.$route.name,
                            language: this.$route.params.lang,
                            demand_id: demand_id,
                        }
                        }

                        this.trackMixpanelEvent(eventName, mx_prop)
                    }
                    } catch (error) {
                    // TODO
                    // this.closeModal()
                    // this.$emit('update-demand-list', error)
                    this.toast('danger', 'b-toaster-bottom-center', this.$t('message.placeBidFailedText'), true)
                    }
                }else{
                    console.log("item_123",JSON.stringify(this.item));
                    this.closeModal()
                    MX_TRACK(config.MIXPANEL_EVENTS.OPEN_LOGIN_PAGE, {demand_id: this.item.demand_id})
                    this.$emit('user-login',this.item,reqData)
                    // alert("dd")
                    // this.$emit('click-bid-now', this.item)
                }
                this.showPlaceBidLoader = false
            }

        },
    handleChangePrice(type) {
      this.rate_received = (type == "increment") ? parseInt(this.rate_received) + this.stepperValue : parseInt(this.rate_received) - this.stepperValue;
      const stepperCount = this.stepperCount;
      let eventName = ""
      if (type == 'increment') {
        stepperCount.up = stepperCount.up + 1
        eventName = config.MIXPANEL_EVENTS.EDIT_BID_ON_STEPPER_UP
      } else {
        stepperCount.down = stepperCount.down + 1
        eventName = config.MIXPANEL_EVENTS.EDIT_BID_ON_STEPPER_DOWN
      }
      this.stepperCount = stepperCount
      const mx_prop = {
        original_bid: this.item.demand_status_details.rate,
        previous_bid: this.item.demand_status_details.rate,
        lowest_bid: this.item.demand_status_details.lowest_bid.rate,
        demand_status: this.item.demand_status_details.status,
        stepper_up_count: this.stepperCount.up,
        stepper_down_count: this.stepperCount.down,
        stepper_value_amount: this.stepperValue
      }

      this.trackMixpanelEvent(eventName, mx_prop)
    },
    closeModal() {
      this.resetForm()
      this.$bvModal.hide('ft-demand-details-modal')
    },
    resetForm() {
      this.$v.$reset()
      if (!this.editMode) {
        this.rate_received = 0
        // this.vehicle_qty = 0
      } else {
        this.editMode = this.item.demand_status_details?.is_edit_allowed
        this.rate_received = this.item.demand_status_details?.rate || 0
        this.vehicle_qty = this.item?.trucks_required || 0
      }
    },
    toast(variant, toaster, text, append = false) {
      this.$bvToast.toast(text, {
        toaster: toaster,
        solid: true,
        variant: variant,
        appendToast: append,
        noCloseButton: true
      })
    },
    onClickInputQty() {
      this.trackMixpanelEvent('ON_CLICK_QUANTITY', {'QTY': this.vehicle_qty})
    },
    trackMixpanelEvent(event, data = {}) {
      const demandDetails = this.item
      const mx_prop = {
        user_type: demandDetails.user_type,
        user_name: demandDetails.supplier_name,
        phone_number: demandDetails.contact,
        language: this.$route.params.lang,
        demand_id: demandDetails.demand_id,
        demand_status: '',
        bid_status: demandDetails.status,
      }
      MX_TRACK(event, {...mx_prop, ...data})
    },
  },
}
</script>

<style lang="scss">

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

#ft-demand-details-modal {
  .modal-content {
    min-height: 0px;
  }

  .modal-body {
    padding: 0;
  }

  .place-bid-btn {
    button {
      background-color: #1F1F1F;
    }
  }
}
</style>